module.exports = "../../static/img/card4.e01218c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile/card4.png
// module id = Q6os
// module chunks = 1